export const isMobile = window.innerWidth < 500;
export const isDesktop = window.innerWidth > 500;
